module.exports = __webpack_public_path__ + "static/media/london_getty_mobile.99d5973e.jpg";